import $ from 'jquery';

export default function() {
  var checked_fuels = $("#fuel_tech_search input[name='fuel_ids[]']:checked");
  if(checked_fuels.length == $("#fuel_tech_search input[name='fuel_ids[]']").length){
    $("#fuel_name").html("All");
  } else if ( checked_fuels.length == 0 ) {
    $("#fuel_name").html("None");
  } else {
    var fuels = [];
    $.each( checked_fuels , function(num, elem) {
      try {
        fuels[num] = $(elem).siblings(".facet_label").text().trim();
      } catch {
        fuels[num] = $(elem).siblings(".facet_label").text();
      }
    });
    $("#fuel_name").html(fuels.join(", "));
  }
}
